import { useTranslation } from "@sagot/i18n";
import { Field, Select } from "@sagot/ui";
import { NEW_PATH } from "../definition-model";

const F = "engage.workflows.fields";

interface PathPickerProps {
  value: string | undefined;
  paths: string[];
  canAddPath: boolean;
  /** Text of the empty choice ("End the run", "Choose a path"); without it a path must be picked. */
  emptyLabel?: string;
  /** Accessible name when the picker has no visible label of its own. */
  label?: string;
  className?: string;
  disabled: boolean;
  onChange: (path: string | undefined) => void;
}

/** A list of the workflow's paths, plus "New path" while another one can be created. */
export function PathPicker({ value, paths, canAddPath, emptyLabel, label, className, disabled, onChange }: PathPickerProps) {
  const { t } = useTranslation();
  const known = !value || paths.includes(value);
  return (
    <Select aria-label={label} className={className} value={value ?? ""} disabled={disabled} onChange={(e) => { onChange(e.target.value || undefined); }}>
      {emptyLabel ? <option value="">{emptyLabel}</option> : null}
      {known ? null : <option value={value}>{t("engage.workflows.builder.path", { id: value })}</option>}
      {paths.map((path) => <option key={path} value={path}>{t("engage.workflows.builder.path", { id: path })}</option>)}
      {canAddPath ? <option value={NEW_PATH}>{t(`${F}.newPath`)}</option> : null}
    </Select>
  );
}

/** `PathPicker` with a visible label. */
export function PathSelect({ label, hint, ...picker }: PathPickerProps & { label: string; hint?: string }) {
  return (
    <Field label={label} hint={hint}>
      <PathPicker {...picker} label={undefined} />
    </Field>
  );
}
